import { call, put, select, take } from 'redux-saga/effects';
import { IAppState } from '../../../common/state';
import { getOffers as getGKs } from '../../../filters/api/ab/newbuilding';
import { IJsonQuery } from '../../../json_query';
import { getJsonQueryForSort } from '../../../utils/sort_request';

export interface ISearchRequestStartRequestedAction {
  type: 'filters/search/NEWBUILDIBG_SEARCH_REQUEST_START_REQUESTED';
}

export interface INewbuildingSearchOffersDesktopResponse200 {
  status: 'ok' | 'validationError';
  response: {
    fullUrl: 'private' | 'public' | 'legacy';
  };
}

export function makeNewbuildingSearch(): ISearchRequestStartRequestedAction {
  return {
    type: 'filters/search/NEWBUILDIBG_SEARCH_REQUEST_START_REQUESTED',
  };
}

export function* newbuildingSearchSaga() {
  while (true) {
    yield take('filters/search/NEWBUILDIBG_SEARCH_REQUEST_START_REQUESTED');

    let state: IAppState = yield select();

    if (state.filters.jsonQueryCountRefresing) {
      // Block search while meta is loading
      yield take(['filters/meta/META_REFRESH_COMPLETE', 'filters/meta/META_REFRESH_FAILED']);
    }

    state = yield select();
    const {
      httpApi,
      filters: { jsonQuery },
      currentSubdomain,
    } = state;

    let jsonQueryForSort: IJsonQuery | undefined = getJsonQueryForSort(jsonQuery);

    const response: INewbuildingSearchOffersDesktopResponse200 = yield call(
      getGKs,
      httpApi,
      { jsonQuery: jsonQueryForSort || jsonQuery },
      currentSubdomain,
    );
    if (response.response && response.response.fullUrl) {
      return window.location.assign(response.response.fullUrl);
    }

    window.location.assign('/novostroyki/');

    return yield put({
      type: 'filters/search/NEWBUILDIBG_SEARCH_REQUEST_END_REQUESTED',
    });
  }
}
